import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { logger } from '@/utils/logger'

import { buildCookie } from '@/modules/cdn/cookie'
import { ApiTaCt100 } from '@/endpoints/ApiTaCt100'

interface CmsTokenData {
    cmsToken: string
}
const getEmptyCmsToken = (): CmsTokenData => ({
    cmsToken: '',
})

@Module({
    stateFactory: true,
    namespaced: true,
    name: 'apis/CmsToken',
})
export default class CmsToken extends VuexModule {
    // States
    private cmsToken_ = getEmptyCmsToken()

    // Getters
    get cmsCookie(): (expiresAt?: string) => string {
        return (expiresAt?: string) => buildCookie(this.cmsToken_.cmsToken, expiresAt)
    }
    
    // Mutations
    @Mutation
    updateCmsToken(value: CmsTokenData) {
        this.cmsToken_ = value
    }

    // Actions
    @Action
    clear() {
        this.context.commit('updateCmsToken', getEmptyCmsToken())
    }

    @Action
    async getCmsToken() {
        logger.trace('in: getCmsToken')
        const api = new ApiTaCt100.Api()

        // API: ApiTaCt100
        const result = await api.get<CmsTokenData | null>(
            {},
            // success
            (data, _) => {
                return {
                    cmsToken: data.cmsToken,
                }
            },
            // Error
            (data, status) => {
                logger.error(status, data)
                return null
            }
        )

        if (result) {
            this.context.commit('updateCmsToken', result)
        }
    }
}